import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2, XCircle } from 'lucide-react';
export function WhoIsItFor() {
  const forWho = ['Empleados que sienten que su entorno laboral es una carga insoportable.', 'Profesionales que sufren ansiedad los domingos por la noche.', 'Personas que trabajan con gente tóxica o manipuladora.', 'Quienes quieren rendir bien pero sin quemar su salud en el proceso.'];
  const notForWho = ['Personas que buscan una solución mágica sin aplicar límites claros.', 'Quienes creen que la empresa es su familia y no un intercambio comercial.'];
  return <section className="bg-primary-dark text-text-dark py-20 md:py-28 border-t border-secondary-dark" data-id="element-227">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-228">
        <div className="grid md:grid-cols-2 gap-12 md:gap-8" data-id="element-229">
          {/* For Who */}
          <FadeIn direction="right" data-id="element-230">
            <div className="bg-secondary-dark/30 border border-green-900/30 rounded-2xl p-8 md:p-10 h-full" data-id="element-231">
              <h3 className="text-2xl md:text-3xl font-bold mb-8 text-white flex items-center gap-3" data-id="element-232">
                <span className="bg-green-500/20 text-green-400 p-2 rounded-lg" data-id="element-233">
                  <CheckCircle2 size={24} data-id="element-234" />
                </span>
                Esto ES para vos si:
              </h3>
              <ul className="space-y-6" data-id="element-235">
                {forWho.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-236">
                    <CheckCircle2 className="text-green-400 shrink-0 mt-1" size={20} data-id="element-237" />
                    <span className="text-text-muted text-lg leading-relaxed" data-id="element-238">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* Not For Who */}
          <FadeIn direction="left" delay={0.2} data-id="element-239">
            <div className="bg-secondary-dark/30 border border-red-900/30 rounded-2xl p-8 md:p-10 h-full" data-id="element-240">
              <h3 className="text-2xl md:text-3xl font-bold mb-8 text-white flex items-center gap-3" data-id="element-241">
                <span className="bg-red-500/20 text-red-400 p-2 rounded-lg" data-id="element-242">
                  <XCircle size={24} data-id="element-243" />
                </span>
                Esto NO es para vos si:
              </h3>
              <ul className="space-y-6" data-id="element-244">
                {notForWho.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-245">
                    <XCircle className="text-red-400 shrink-0 mt-1" size={20} data-id="element-246" />
                    <span className="text-text-muted text-lg leading-relaxed" data-id="element-247">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}